var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60449 8.70801C1.60449 8.32831 1.9123 8.02051 2.29199 8.02051H19.7087C20.0884 8.02051 20.3962 8.32831 20.3962 8.70801V18.333C20.3962 19.219 19.678 19.9372 18.792 19.9372H3.20866C2.32271 19.9372 1.60449 19.219 1.60449 18.333V8.70801ZM2.97949 9.39551V18.333C2.97949 18.4596 3.08209 18.5622 3.20866 18.5622H18.792C18.9186 18.5622 19.0212 18.4596 19.0212 18.333V9.39551H2.97949Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20866 3.89551C3.08209 3.89551 2.97949 3.99811 2.97949 4.12467V8.02051H19.0212V4.12467C19.0212 3.9981 18.9186 3.89551 18.792 3.89551H3.20866ZM1.60449 4.12467C1.60449 3.23872 2.3227 2.52051 3.20866 2.52051H18.792C19.678 2.52051 20.3962 3.23872 20.3962 4.12467V8.70801C20.3962 9.0877 20.0884 9.39551 19.7087 9.39551H2.29199C1.9123 9.39551 1.60449 9.0877 1.60449 8.70801V4.12467Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33301 1.14551C7.7127 1.14551 8.02051 1.45331 8.02051 1.83301V5.49967C8.02051 5.87937 7.7127 6.18717 7.33301 6.18717C6.95331 6.18717 6.64551 5.87937 6.64551 5.49967V1.83301C6.64551 1.45331 6.95331 1.14551 7.33301 1.14551Z",
    fill: "#1C1B1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.667 1.14551C15.0467 1.14551 15.3545 1.45331 15.3545 1.83301V5.49967C15.3545 5.87937 15.0467 6.18717 14.667 6.18717C14.2873 6.18717 13.9795 5.87937 13.9795 5.49967V1.83301C13.9795 1.45331 14.2873 1.14551 14.667 1.14551Z",
    fill: "#1C1B1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1455 15.583C12.1455 15.2033 12.4533 14.8955 12.833 14.8955H15.583C15.9627 14.8955 16.2705 15.2033 16.2705 15.583C16.2705 15.9627 15.9627 16.2705 15.583 16.2705H12.833C12.4533 16.2705 12.1455 15.9627 12.1455 15.583Z",
    fill: "#1C1B1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72949 15.583C5.72949 15.2033 6.0373 14.8955 6.41699 14.8955H9.16699C9.54669 14.8955 9.85449 15.2033 9.85449 15.583C9.85449 15.9627 9.54669 16.2705 9.16699 16.2705H6.41699C6.0373 16.2705 5.72949 15.9627 5.72949 15.583Z",
    fill: "#1C1B1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1455 11.917C12.1455 11.5373 12.4533 11.2295 12.833 11.2295H15.583C15.9627 11.2295 16.2705 11.5373 16.2705 11.917C16.2705 12.2967 15.9627 12.6045 15.583 12.6045H12.833C12.4533 12.6045 12.1455 12.2967 12.1455 11.917Z",
    fill: "#1C1B1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72949 11.917C5.72949 11.5373 6.0373 11.2295 6.41699 11.2295H9.16699C9.54669 11.2295 9.85449 11.5373 9.85449 11.917C9.85449 12.2967 9.54669 12.6045 9.16699 12.6045H6.41699C6.0373 12.6045 5.72949 12.2967 5.72949 11.917Z",
    fill: "#1C1B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlack);
export default __webpack_public_path__ + "static/media/calendar-black.28c6fcf19e701f39245d12d8c64d8180.svg";
export { ForwardRef as ReactComponent };